
import { Component, Vue } from "vue-property-decorator"

import VuePerfectScrollbar from "vue-perfect-scrollbar"

@Component({
	components: {
		"scrollbar": VuePerfectScrollbar
	}
})
export default class RetractableSidebar extends Vue {
	private expanded: boolean = true;

	private toggleExpand (): void {
		this.expanded = !this.expanded
	}
}

